import { Controller } from 'stimulus';
import gsap from 'gsap';
import jump from 'jump.js';

class HeroController extends Controller {
  connect() {
    this.timeline = gsap.timeline({
      paused: true,
    });

    this.timeline
      .from(this.backgroundImageTarget, { scale: 1 })
      .to(this.backgroundImageTarget, { scale: 1.1 });
  }

  onArrowClick() {
    const nextElement = this.element.nextElementSibling;

    if (nextElement) {
      jump(nextElement);
    }
  }

  scrollHandler(currentElementObject) {
    this.timeline.progress(currentElementObject.progress).pause();
  }
}

HeroController.targets = [
  'backgroundImage',
];

export default HeroController;
